import { AlgoliaEnvironment } from '@atlassian/mpac-types';
const searchIndicesV3 = {
  [AlgoliaEnvironment.DEV]: {
    indexName: 'marketplace_plugins_stg_v3'
  },
  [AlgoliaEnvironment.STG]: {
    indexName: 'marketplace_plugins_stg_v3'
  },
  [AlgoliaEnvironment.PROD]: {
    indexName: 'marketplace_plugins_prod_v3'
  }
};
const searchIndicesV4 = {
  [AlgoliaEnvironment.DEV]: {
    indexName: 'marketplace_plugins_stg_v4'
  },
  [AlgoliaEnvironment.STG]: {
    indexName: 'marketplace_plugins_stg_v4'
  },
  [AlgoliaEnvironment.PROD]: {
    indexName: 'marketplace_plugins_prod_v4'
  }
};
export { searchIndicesV3, searchIndicesV4 };